import React from 'react';

export const initialsOf = (name: string): string =>
  name.split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]?.toUpperCase()).join('') || '?';

/** Runder Avatar mit Initialen, getönt in der Farbe der Person (Mitarbeiterfarbe im Kalender). */
export const Avatar: React.FC<{ name: string; color?: string; size?: number }> = ({ name, color, size = 32 }) => (
  <span
    className="ui-avatar"
    style={{
      width: size,
      height: size,
      fontSize: Math.round(size * 0.38),
      ...(color ? { background: `color-mix(in srgb, ${color} 18%, #fff)`, color } : {}),
    }}
    aria-hidden
  >
    {initialsOf(name)}
  </span>
);

/** Name mit Avatar und einer zweiten, leisen Zeile (Personalnummer, Kundennummer …). */
export const PersonCell: React.FC<{ name: string; sub?: React.ReactNode; color?: string; muted?: boolean }> = ({ name, sub, color, muted }) => (
  <span className={`ui-person${muted ? ' is-muted' : ''}`}>
    <Avatar name={name || '?'} color={color} />
    <span className="ui-person__text">
      <span className="ui-person__name">{name || 'Ohne Namen'}</span>
      {sub && <span className="ui-person__sub">{sub}</span>}
    </span>
  </span>
);

const DAYS = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

/** Sieben Kästchen Mo–So; gefüllt sind die Tage, an denen gearbeitet bzw. besucht wird. */
export const WeekdayDots: React.FC<{ days: number[]; titles?: Record<number, string> }> = ({ days, titles }) => (
  <span className="ui-week" aria-label={days.length ? `Tage: ${days.map(d => DAYS[d - 1]).join(', ')}` : 'keine Tage'}>
    {DAYS.map((label, i) => (
      <span key={label} className={days.includes(i + 1) ? 'is-on' : ''} title={titles?.[i + 1] ?? label}>
        {label[0]}
      </span>
    ))}
  </span>
);
